<ng-container *ngIf="survey && surveyForms.length > 0">
  <mec-custom-form
    (hasCustomForms)="hasCustomForms = $event"
    [customForms]="surveyForms"
    [removePadding]="true"
    [type]="surveyFormType"
  ></mec-custom-form>
</ng-container>
